import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageLTLControl extends Layout {
    buttonLTLQuoteFormatButton: Button;
    checkboxAutoAddProductBook: Checkbox;
    checkboxCalcWeightFromTliTariff: Checkbox;
    checkboxCarrierSelectExpandAll: Checkbox;
    checkboxDefInclBfgOnLtlQuotes: Checkbox;
    checkboxEnableTbreCompareOption: Checkbox;
    checkboxLtlBrkBolBillingTerms: Checkbox;
    checkboxLtlClassWarning: Checkbox;
    checkboxLtlDefaultOpenClose: Checkbox;
    checkboxLtlPersistZeroAmtRevs: Checkbox;
    checkboxShowasLocation: Checkbox;
    checkboxUseSmc3GeneratedBol: Checkbox;
    dataheaderTitle: DataHeader;
    labelCubicUnitDensityWarning: Label;
    panelCubicUnitsDensityWarning: Panel;
    panelOrder: Panel;
    panelRateException: Panel;
    panelRating: Panel;
    sourceDispatchControl: DataSource;
    sourceRateExceptionDispatchControl: DataSource;
    tabOrder: Tab;
    tabRateException: Tab;
    tabRating: Tab;
    tableBrokerageLTLRateExceptions: Table;
    tabsetBrokerageLTL: Tabset;
    textboxBlanketBuyTariffId: Textbox;
    textboxBlanketSellTariffId: Textbox;
    textboxBrkQuoteTemplate: Textbox;
    textboxCarrierAssignmentPrompt: Textbox;
    textboxCarrierSelectionSort: Textbox;
    textboxCubicGreaterThan: Textbox;
    textboxDefaultBuyTariffId: Textbox;
    textboxDefaultSellTariffId: Textbox;
    textboxDensityGreaterThan: Textbox;
    textboxIncludeQuoteNumberInBol: Textbox;
    textboxLtlCarrierBrkStatus: Textbox;
    textboxLtlCubicUnitsWarning: Textbox;
    textboxLtlDensityWarning: Textbox;
    textboxLtlFreightDimensionUom: Textbox;
    textboxQualifyWeightbreaksBy: Textbox;
    textboxRateExceptionUomList: Textbox;
    textboxRateUsingTariff: Textbox;
    textboxRateUsingTariffCodes: Textbox;
    textboxRerateConsignedBfg: Textbox;
}
